var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsActiveDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7493 7.68385C15.241 7.68385 14.6243 6.61718 15.3743 5.30885C15.8077 4.55052 15.5493 3.58385 14.791 3.15052L13.3493 2.32552C12.691 1.93385 11.841 2.16718 11.4493 2.82552L11.3577 2.98385C10.6077 4.29218 9.37435 4.29218 8.61602 2.98385L8.52435 2.82552C8.14935 2.16718 7.29935 1.93385 6.64102 2.32552L5.19935 3.15052C4.44102 3.58385 4.18268 4.55885 4.61602 5.31718C5.37435 6.61718 4.75768 7.68385 3.24935 7.68385C2.38268 7.68385 1.66602 8.39218 1.66602 9.26718V10.7338C1.66602 11.6005 2.37435 12.3172 3.24935 12.3172C4.75768 12.3172 5.37435 13.3838 4.61602 14.6922C4.18268 15.4505 4.44102 16.4172 5.19935 16.8505L6.64102 17.6755C7.29935 18.0672 8.14935 17.8339 8.54102 17.1755L8.63268 17.0172C9.38268 15.7088 10.616 15.7088 11.3743 17.0172L11.466 17.1755C11.8577 17.8339 12.7077 18.0672 13.366 17.6755L14.8077 16.8505C15.566 16.4172 15.8243 15.4422 15.391 14.6922C14.6327 13.3838 15.2493 12.3172 16.7577 12.3172C17.6243 12.3172 18.341 11.6088 18.341 10.7338V9.26718C18.3327 8.40052 17.6243 7.68385 16.7493 7.68385ZM9.99935 12.7088C8.50768 12.7088 7.29102 11.4922 7.29102 10.0005C7.29102 8.50885 8.50768 7.29218 9.99935 7.29218C11.491 7.29218 12.7077 8.50885 12.7077 10.0005C12.7077 11.4922 11.491 12.7088 9.99935 12.7088Z",
    fill: "url(#paint0_linear_7035_124434)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7035_124434",
    x1: 10.0035,
    y1: 2.13477,
    x2: 10.0035,
    y2: 17.8663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsActiveDark);
export default __webpack_public_path__ + "static/media/settings-active-dark.97aa99d7fde74e4d1f33d4bbf75540b7.svg";
export { ForwardRef as ReactComponent };